'use strict';

const $ = require('jquery');
const Flickity = require('flickity/dist/flickity.pkgd.js');

const SELECTORS = {
    SCROLLER: '.js-scroller'
};

function init() {
    var scroller = $(SELECTORS.SCROLLER);

    if (!scroller.length) {
        return false;
    }

    setTimeout(function(){
        [].forEach.call(document.querySelectorAll('.js-scroller'), function (elem) {
            new Flickity( elem, {
                cellAlign: 'left',
                contain: true,
                freeScroll: true,
                pageDots: false,
                groupCells: true,
                watchCSS: true,
                freeScrollFriction: 0.03
            });
        });
    }, 2000);

    Flickity.prototype._createResizeClass = function() {
      this.element.classList.add('flickity-resize');
    };

    Flickity.createMethods.push('_createResizeClass');

    var resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function() {
      this.element.classList.remove('flickity-resize');
      resize.call( this );
      this.element.classList.add('flickity-resize');
    };
}

module.exports = {
    init: init
};
